import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import SEO from '../components/SEO';

const PrivacyPolicy = () => {
  const { language } = useLanguage();

  const content = {
    ro: {
      title: 'Politica de Confidențialitate',
      lastUpdated: 'Ultima actualizare: 15 Noiembrie 2025',
      sections: [
        {
          title: '1. Introducere',
          content: `FinanciallyFree.ro ("noi", "al nostru") respectă confidențialitatea datelor tale personale. Această Politică de Confidențialitate explică ce informații colectăm, cum le folosim și ce drepturi ai în legătură cu datele tale personale, conform Regulamentului General privind Protecția Datelor (GDPR).`
        },
        {
          title: '2. Date Personale Colectate',
          content: `<strong>2.1 Informații furnizate direct de tine:</strong>
          <ul>
            <li>Nume și prenume (când te înregistrezi)</li>
            <li>Adresă de email</li>
            <li>Date de plată (procesate securizat prin Stan.store - nu stocăm direct)</li>
          </ul>
          
          <strong>2.2 Informații colectate automat:</strong>
          <ul>
            <li>Adresa IP</li>
            <li>Tipul și versiunea browser-ului</li>
            <li>Pagini vizitate și durata vizitei</li>
            <li>Date de acces (data și ora)</li>
            <li>Cookie-uri (vezi secțiunea Cookie-uri)</li>
          </ul>`
        },
        {
          title: '3. Scopul Prelucrării Datelor',
          content: `Folosim datele tale pentru:
          <ul>
            <li><strong>Furnizarea serviciilor:</strong> Crearea contului, accesul la conținut premium</li>
            <li><strong>Comunicare:</strong> Newsletter, răspunsuri la întrebări, actualizări importante</li>
            <li><strong>Îmbunătățirea site-ului:</strong> Analiza traficului, optimizare experiență utilizator</li>
            <li><strong>Marketing:</strong> Promovarea produselor și serviciilor (doar cu acordul tău)</li>
            <li><strong>Obligații legale:</strong> Facturare, raportări fiscale</li>
          </ul>`
        },
        {
          title: '4. Temeiul Legal (GDPR)',
          content: `Prelucrăm datele tale pe baza:
          <ul>
            <li><strong>Consimțământului:</strong> Newsletter, marketing (poți retrage oricând)</li>
            <li><strong>Executarea contractului:</strong> Furnizarea produselor digitale cumpărate</li>
            <li><strong>Interesul legitim:</strong> Analiza traficului, îmbunătățirea serviciilor</li>
            <li><strong>Obligații legale:</strong> Facturare, arhivare</li>
          </ul>`
        },
        {
          title: '5. Cookie-uri',
          content: `<strong>Ce sunt cookie-urile?</strong>
          Cookie-urile sunt fișiere mici stocate pe dispozitivul tău.
          
          <strong>Tipuri de cookie-uri folosite:</strong>
          <ul>
            <li><strong>Cookie-uri necesare:</strong> Esențiale pentru funcționarea site-ului (autentificare, preferințe)</li>
            <li><strong>Cookie-uri de analiză:</strong> Google Analytics - pentru înțelegerea traficului</li>
            <li><strong>Cookie-uri de marketing:</strong> Facebook Pixel - pentru reclame relevante</li>
          </ul>
          
          <strong>Controlul cookie-urilor:</strong>
          Poți gestiona preferințele de cookie-uri în bannerul afișat la prima vizită sau în setările browser-ului.
          
          <strong>Google Analytics:</strong> Folosim GA4 pentru statistici anonimizate. Poți renunța aici: <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:underline">Google Analytics Opt-out</a>`
        },
        {
          title: '6. Partajarea Datelor',
          content: `<strong>Nu vindem datele tale.</strong> Partajăm date doar cu:
          <ul>
            <li><strong>Furnizori de servicii:</strong> Stan.store (plăți), ConvertKit/Mailerlite (email marketing), Google Analytics, Facebook</li>
            <li><strong>Autorități:</strong> Doar dacă legea o impune</li>
          </ul>
          
          Toți partenerii respectă GDPR și au măsuri de securitate adecvate.`
        },
        {
          title: '7. Transferul Internațional de Date',
          content: `Unii furnizori (ex: Google, Facebook) pot procesa date în afara UE/SEE. Aceste transferuri sunt protejate prin:
          <ul>
            <li>Clauze contractuale standard aprobate de UE</li>
            <li>Certificări Privacy Shield (unde aplicabil)</li>
            <li>Măsuri de securitate echivalente GDPR</li>
          </ul>`
        },
        {
          title: '8. Perioada de Stocare',
          content: `<ul>
            <li><strong>Conturi active:</strong> Cât timp contul este activ</li>
            <li><strong>Conturi inactive:</strong> 3 ani, apoi ștergere automată</li>
            <li><strong>Newsletter:</strong> Până la dezabonare</li>
            <li><strong>Date financiare:</strong> 10 ani (obligație legală fiscală)</li>
          </ul>`
        },
        {
          title: '9. Drepturile Tale (GDPR)',
          content: `Ai următoarele drepturi:
          <ul>
            <li><strong>Dreptul de acces:</strong> Să știi ce date avem despre tine</li>
            <li><strong>Dreptul de rectificare:</strong> Să corectezi date incorecte</li>
            <li><strong>Dreptul de ștergere ("dreptul de a fi uitat"):</strong> Să ștergi contul și datele</li>
            <li><strong>Dreptul de restricționare:</strong> Să limitezi prelucrarea în anumite situații</li>
            <li><strong>Dreptul la portabilitate:</strong> Să primești datele în format structurat</li>
            <li><strong>Dreptul de opoziție:</strong> Să te opui prelucrării (ex: marketing)</li>
            <li><strong>Dreptul de a retrage consimțământul:</strong> Oricând, fără afectarea legalității prelucrării anterioare</li>
          </ul>
          
          <strong>Cum îți exerciți drepturile:</strong>
          Trimite email la: <a href="mailto:contact@financiallyfree.ro" class="text-blue-600 hover:underline">contact@financiallyfree.ro</a>
          Răspundem în maxim 30 de zile.`
        },
        {
          title: '10. Securitatea Datelor',
          content: `Implementăm măsuri tehnice și organizatorice pentru protecția datelor:
          <ul>
            <li>Criptare SSL/TLS pentru transmisia datelor</li>
            <li>Parole hashate (nu stocăm parole în clar)</li>
            <li>Backup-uri regulate</li>
            <li>Acces restricționat la date (doar personal autorizat)</li>
            <li>Monitorizare activități suspecte</li>
          </ul>`
        },
        {
          title: '11. Minori',
          content: `Site-ul nu este destinat copiilor sub 16 ani. Nu colectăm cu intenție date de la minori. Dacă ești părinte și descoperi că minorul tău a furnizat date, contactează-ne pentru ștergere.`
        },
        {
          title: '12. Modificări ale Politicii',
          content: `Putem actualiza această politică. Modificările semnificative vor fi anunțate prin email sau notificare pe site. Data ultimei actualizări este afișată în partea de sus.`
        },
        {
          title: '13. Plângeri',
          content: `Dacă consideri că drepturile tale GDPR au fost încălcate, poți depune plângere la:
          <strong>Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP)</strong>
          <br/>Email: <a href="mailto:anspdcp@dataprotection.ro" class="text-blue-600 hover:underline">anspdcp@dataprotection.ro</a>
          <br/>Website: <a href="https://www.dataprotection.ro" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:underline">www.dataprotection.ro</a>`
        },
        {
          title: '14. Contact',
          content: `Pentru orice întrebări despre confidențialitate:
          <br/><strong>Email:</strong> <a href="mailto:contact@financiallyfree.ro" class="text-blue-600 hover:underline">contact@financiallyfree.ro</a>
          <br/><strong>Responsabil Protecția Datelor (DPO):</strong> contact@financiallyfree.ro`
        }
      ]
    },
    en: {
      title: 'Privacy Policy',
      lastUpdated: 'Last updated: November 15, 2025',
      sections: [
        {
          title: '1. Introduction',
          content: `FinanciallyFree.ro ("we", "our") respects your personal data privacy. This Privacy Policy explains what information we collect, how we use it, and your rights regarding your personal data, in compliance with the General Data Protection Regulation (GDPR).`
        },
        {
          title: '2. Personal Data Collected',
          content: `<strong>2.1 Information you provide directly:</strong>
          <ul>
            <li>Name and surname (when registering)</li>
            <li>Email address</li>
            <li>Payment data (processed securely through Stan.store - we don't store directly)</li>
          </ul>
          
          <strong>2.2 Automatically collected information:</strong>
          <ul>
            <li>IP address</li>
            <li>Browser type and version</li>
            <li>Pages visited and visit duration</li>
            <li>Access data (date and time)</li>
            <li>Cookies (see Cookies section)</li>
          </ul>`
        },
        {
          title: '3. Purpose of Data Processing',
          content: `We use your data for:
          <ul>
            <li><strong>Service provision:</strong> Account creation, premium content access</li>
            <li><strong>Communication:</strong> Newsletter, answering questions, important updates</li>
            <li><strong>Site improvement:</strong> Traffic analysis, user experience optimization</li>
            <li><strong>Marketing:</strong> Promoting products and services (only with your consent)</li>
            <li><strong>Legal obligations:</strong> Invoicing, tax reporting</li>
          </ul>`
        },
        {
          title: '4. Legal Basis (GDPR)',
          content: `We process your data based on:
          <ul>
            <li><strong>Consent:</strong> Newsletter, marketing (you can withdraw anytime)</li>
            <li><strong>Contract execution:</strong> Providing purchased digital products</li>
            <li><strong>Legitimate interest:</strong> Traffic analysis, service improvement</li>
            <li><strong>Legal obligations:</strong> Invoicing, archiving</li>
          </ul>`
        },
        {
          title: '5. Cookies',
          content: `<strong>What are cookies?</strong>
          Cookies are small files stored on your device.
          
          <strong>Types of cookies used:</strong>
          <ul>
            <li><strong>Necessary cookies:</strong> Essential for site functionality (authentication, preferences)</li>
            <li><strong>Analytics cookies:</strong> Google Analytics - for traffic understanding</li>
            <li><strong>Marketing cookies:</strong> Facebook Pixel - for relevant ads</li>
          </ul>
          
          <strong>Cookie control:</strong>
          You can manage cookie preferences in the banner shown on first visit or in browser settings.
          
          <strong>Google Analytics:</strong> We use GA4 for anonymized statistics. Opt-out here: <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:underline">Google Analytics Opt-out</a>`
        },
        {
          title: '6. Data Sharing',
          content: `<strong>We don't sell your data.</strong> We share data only with:
          <ul>
            <li><strong>Service providers:</strong> Stan.store (payments), ConvertKit/Mailerlite (email marketing), Google Analytics, Facebook</li>
            <li><strong>Authorities:</strong> Only if required by law</li>
          </ul>
          
          All partners comply with GDPR and have adequate security measures.`
        },
        {
          title: '7. International Data Transfer',
          content: `Some providers (e.g., Google, Facebook) may process data outside EU/EEA. These transfers are protected through:
          <ul>
            <li>EU-approved standard contractual clauses</li>
            <li>Privacy Shield certifications (where applicable)</li>
            <li>GDPR-equivalent security measures</li>
          </ul>`
        },
        {
          title: '8. Storage Period',
          content: `<ul>
            <li><strong>Active accounts:</strong> While account is active</li>
            <li><strong>Inactive accounts:</strong> 3 years, then automatic deletion</li>
            <li><strong>Newsletter:</strong> Until unsubscribe</li>
            <li><strong>Financial data:</strong> 10 years (legal tax obligation)</li>
          </ul>`
        },
        {
          title: '9. Your Rights (GDPR)',
          content: `You have the following rights:
          <ul>
            <li><strong>Right of access:</strong> Know what data we have about you</li>
            <li><strong>Right to rectification:</strong> Correct inaccurate data</li>
            <li><strong>Right to erasure ("right to be forgotten"):</strong> Delete account and data</li>
            <li><strong>Right to restriction:</strong> Limit processing in certain situations</li>
            <li><strong>Right to portability:</strong> Receive data in structured format</li>
            <li><strong>Right to object:</strong> Object to processing (e.g., marketing)</li>
            <li><strong>Right to withdraw consent:</strong> Anytime, without affecting lawfulness of prior processing</li>
          </ul>
          
          <strong>How to exercise your rights:</strong>
          Email us at: <a href="mailto:contact@financiallyfree.ro" class="text-blue-600 hover:underline">contact@financiallyfree.ro</a>
          We respond within 30 days maximum.`
        },
        {
          title: '10. Data Security',
          content: `We implement technical and organizational measures for data protection:
          <ul>
            <li>SSL/TLS encryption for data transmission</li>
            <li>Hashed passwords (we don't store passwords in plain text)</li>
            <li>Regular backups</li>
            <li>Restricted data access (authorized personnel only)</li>
            <li>Suspicious activity monitoring</li>
          </ul>`
        },
        {
          title: '11. Minors',
          content: `The site is not intended for children under 16. We don't intentionally collect data from minors. If you're a parent and discover your minor has provided data, contact us for deletion.`
        },
        {
          title: '12. Policy Changes',
          content: `We may update this policy. Significant changes will be announced via email or site notification. The last update date is displayed at the top.`
        },
        {
          title: '13. Complaints',
          content: `If you believe your GDPR rights have been violated, you can file a complaint with:
          <strong>National Supervisory Authority for Personal Data Processing (ANSPDCP)</strong>
          <br/>Email: <a href="mailto:anspdcp@dataprotection.ro" class="text-blue-600 hover:underline">anspdcp@dataprotection.ro</a>
          <br/>Website: <a href="https://www.dataprotection.ro" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:underline">www.dataprotection.ro</a>`
        },
        {
          title: '14. Contact',
          content: `For any privacy questions:
          <br/><strong>Email:</strong> <a href="mailto:contact@financiallyfree.ro" class="text-blue-600 hover:underline">contact@financiallyfree.ro</a>
          <br/><strong>Data Protection Officer (DPO):</strong> contact@financiallyfree.ro`
        }
      ]
    }
  };

  const t = content[language] || content.ro;
  
  const seoTitle = language === 'ro' 
    ? 'Politica de Confidențialitate - FinanciallyFree.ro'
    : 'Privacy Policy - FinanciallyFree.ro';
    
  const seoDescription = language === 'ro'
    ? 'Politica de confidențialitate și protecția datelor personale conform GDPR. Află cum protejăm informațiile tale.'
    : 'Privacy policy and personal data protection according to GDPR. Learn how we protect your information.';

  return (
    <>
      <SEO 
        title={seoTitle}
        description={seoDescription}
        url="/legal/privacy-policy"
      />
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-mint-50 py-16">
        <div className="page-container">
          <div className="mx-auto max-w-4xl">
            <div className="rounded-2xl bg-white p-8 shadow-lg md:p-12">
              <h1 className="mb-2 text-4xl font-bold text-slate-900">{t.title}</h1>
              <p className="mb-8 text-sm text-slate-500">{t.lastUpdated}</p>
              
              <div className="space-y-8">
                {t.sections.map((section, index) => (
                  <section key={index}>
                    <h2 className="mb-4 text-2xl font-bold text-slate-900">{section.title}</h2>
                    <div 
                      className="prose prose-slate max-w-none text-slate-700"
                      dangerouslySetInnerHTML={{ __html: section.content }}
                    />
                  </section>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;